import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { Virtualizer } from '@tanstack/react-virtual';
import { MutableRefObject, useCallback } from 'react';

export function HOOK_GRID2D_FLOAT__update_possible_on_screen_cells_indices(
  ref_grid: HTMLDivElement | null,
  grid2d_virtual: DTO__grid2d_virtual,
  virtualizer: Virtualizer<HTMLDivElement, Element>,
  ref_first_image_index_on_page: MutableRefObject<number>,
  slug_offset: number,
  ref_is_slug_offset_locked_by_scroll: MutableRefObject<boolean>,
) {
  return useCallback(() => {
    if (!ref_grid) return;
    if (grid2d_virtual.total_columns === 0) return; // grid2d_virtual and virtualizer properties are not calculated yet based on viewport size
    if (ref_is_slug_offset_locked_by_scroll.current) return; // when max_side is changing we need to wait for scroll

    const ref_grid_value = ref_grid;

    const scroll_top = ref_grid_value.scrollTop;
    const viewport_height = ref_grid_value.clientHeight;
    const viewport_bottom = scroll_top + viewport_height;

    const virtual_items = virtualizer.getVirtualItems();

    const visible_virtual_items = virtual_items.filter(item => {
      const item_top = item.start;
      const item_bottom = item.start + item.size;

      return scroll_top < item_bottom && item_top < viewport_bottom;
    });

    const visible_items_indices_absolute = visible_virtual_items.map(item => item.index).filter(index => index !== CONSTANTS__client.VIRTUAL_ITEM_STUB_INDEX);

    update_first_image_index_on_page(visible_items_indices_absolute);
  }, [ref_grid, grid2d_virtual, virtualizer]);

  function update_first_image_index_on_page(visible_items_indices_absolute: number[]) {
    if (visible_items_indices_absolute.length === 0) return;

    const first_image_index = visible_items_indices_absolute[0];

    if (ref_first_image_index_on_page.current === first_image_index) return;

    const total_columns = grid2d_virtual.total_columns;

    const max_index = Math.ceil(slug_offset / total_columns) * total_columns;
    const min_index = Math.floor(slug_offset / total_columns) * total_columns;

    if (first_image_index >= min_index && first_image_index < max_index) {
      ref_first_image_index_on_page.current = slug_offset;
    } else {
      ref_first_image_index_on_page.current = first_image_index;
    }
  }
}
